import { Button } from 'primereact/button';

import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState, useMemo } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import ImageForm from '../../common/image/ImageForm';
import { InputSwitch } from 'primereact/inputswitch';
import { validateURL } from '../../../../utils/stringHelper';
import { InputTextarea } from 'primereact/inputtextarea';

function PopUpManager({ isOpen, onClose, popup, onUpdate, loading, onCreate }) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [buttonLabel, setButtonLabel] = useState('');
  const [buttonLink, setButtonLink] = useState('');
  const [image, setImage] = useState(undefined);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (popup) {
      setTitle(popup.title);
      setContent(popup.content);
      setButtonLabel(popup.button_label);
      setButtonLink(popup.button_link);
      setImage(popup.image);
      setIsActive(popup.is_active);
    } else {
      setTitle('');
      setContent('');
      setButtonLabel('');
      setButtonLink('');
      setImage(undefined);
      setIsActive(false);
    }
  }, [popup, isOpen]);

  const handleValidate = () => {
    const popupPayload = {
      title,
      content,
      button_label: buttonLabel,
      button_link: buttonLink,
      image: image?.id || null,
      is_active: isActive
    };

    popup ? onUpdate(popupPayload) : onCreate(popupPayload);
  };

  const formIsValid = () => {
    return title && content && validateButtonUrl;
  };

  const validateButtonUrl = useMemo(
    () =>
      validateURL(buttonLink) &&
      ((buttonLabel?.length > 0 && buttonLink?.length > 0) ||
        (!buttonLink?.length && !buttonLabel?.length)),
    [buttonLink, buttonLabel]
  );

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${popup ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 600 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${popup ? 'Modifier' : 'Ajouter'} une Pop-Up`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper">
          <FormInput key="title" label={'Titre de la Pop-Up'} required isValid={title}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre de la Pop-Up"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>
          <FormInput key="is_active" label={'Activer la Pop-Up'}>
            <InputSwitch id="is_active" checked={isActive} onChange={(e) => setIsActive(e.value)} />
          </FormInput>
          <FormInput key="content" label={'Contenu de la Pop-Up'} required isValid={content}>
            <InputTextarea
              id="content"
              value={content}
              maxLength={300}
              placeholder="Veuillez saisir le contenu de la Pop-Up"
              onChange={(e) => setContent(e.target.value)}
            />
          </FormInput>
          <FormInput
            label={'Bouton'}
            errorMessage={
              !validateURL(buttonLink)
                ? "L'URL doit commencer par http:// ou https://"
                : !validateButtonUrl
                  ? 'Le bouton doit avoir un Url et un label'
                  : ''
            }>
            <div className="flex flex-row gap-x-3">
              <InputText
                placeholder="Texte du bouton"
                value={buttonLabel}
                onChange={(e) => setButtonLabel(e.target.value)}
                className="grow"
              />

              <InputText
                placeholder="https:// ou http://"
                value={buttonLink}
                onChange={(e) => setButtonLink(e.target.value)}
                className="grow"
                invalid={!validateURL(buttonLink)}
              />
            </div>
          </FormInput>
          <ImageForm
            image={image}
            setImage={setImage}
            deleteImage={() => setImage(undefined)}
            required={false}
          />
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default PopUpManager;
